import api from "./axios";

export default class PremiumService {
  changePremiumNumber = (number: number, type: string) => {
    return api.post("/api/ems/msisdn-swap", {
      msisdn: number,
      type: type,
    });
  };

  getPremiumCategory = () => {
    return api.get("/api/ems/get-msisdn-types");
  };

  getPremiumNumbers = (data: {
    search: string;
    limit: number;
    type: string;
    facilityId: number;
    start?: number;
  }) => {
    return api.get("/api/ems/get-msisdn-list", {
      params: {
        ...data,
      },
    });
  };
}
